export const getOrderCartItems = order => {
  if (order?.items && Array.isArray(order.items)) {
    return order.items;
  }
  return [];
};

export const hasOrderCartItems = order => getOrderCartItems(order).length > 0;

export const formatCartOptionLine = (option, currency = { symbol: '$' }) => {
  const base = `${option.quantity} ${option.title}`;
  const upcharge = Number(option.optionPrice) * Number(option.quantity || 0);
  if (!upcharge) {
    return base;
  }
  return `${base} (+${currency.symbol}${upcharge.toFixed(2)})`;
};

/**
 * GraphQL redeemable fields are snake_case; tolerate camelCase if present.
 */
export const getRedeemableLoyaltyFields = orderRedeemable => {
  if (!orderRedeemable) {
    return { redemptionGroup: undefined, externalId: undefined };
  }
  return {
    redemptionGroup:
      orderRedeemable.redemption_group != null
        ? orderRedeemable.redemption_group
        : orderRedeemable.redemptionGroup,
    externalId:
      orderRedeemable.external_id != null
        ? orderRedeemable.external_id
        : orderRedeemable.externalId,
  };
};
